/* eslint-disable no-console */
/* eslint-disable max-len */
import { useReducer, useCallback } from 'react';
import { FormData, FormAction } from '../types';
import { useSelector } from 'react-redux';

// Initial form state
export const getInitialFormData = (contentManagement: any): FormData =>
{
	return {
		title          : '',
		description    : '',
		enabled        : true,
		allowDownloads : contentManagement?.accessSettings?.download || false,
		allowShare     : contentManagement?.accessSettings?.share || false,
		visibility     : contentManagement?.accessSettings?.public ? 'public' : 'private'
	};
};

// Form reducer function
const formReducer = (state: FormData, action: FormAction, initialState: FormData): FormData =>
{
	switch (action.type)
	{
		case 'UPDATE_FIELD':
			// For boolean toggle fields, ensure they're properly updated
			if (typeof action.value === 'boolean')
			{
				console.log(`Reducer updating ${action.field} to ${action.value}`);
			}

			return {
				...state,
				[action.field] : action.value
			};
		case 'RESET_FORM':
			return initialState;
		default:
			return state;
	}
};

export const useFormState = (category?: any) =>
{
	const contentManagement = useSelector((state: any) => state?.mysession?.configs?.contentManagement);

	const initialState = category
		? {
			title          : category.name || '',
			description    : category.description || '',
			enabled        : category.isEnabled !== undefined ? category.isEnabled : true,
			allowDownloads : category.allowDownloads !== undefined ? category.allowDownloads : contentManagement?.accessSettings?.download,
			allowShare     : category.allowShare !== undefined ? category.allowShare : contentManagement?.accessSettings?.share,
			visibility     : category.visibility || (contentManagement?.accessSettings?.public ? 'public' : 'private')
		}
		: getInitialFormData(contentManagement);

	const [ formData, dispatchForm ] = useReducer(
		(state: FormData, action: FormAction) => formReducer(state, action, initialState),
		initialState
	);

	const handleFormUpdate = useCallback((field: keyof FormData, value: any) =>
	{
		dispatchForm({ type: 'UPDATE_FIELD', field, value });
	}, []);

	return {
		formData,
		dispatchForm,
		handleFormUpdate
	};
};